import script from "./AdminMaterialView.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminMaterialView.vue?vue&type=script&setup=true&lang=js"

import "./AdminMaterialView.vue?vue&type=style&index=0&id=36867436&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-36867436"]])

export default __exports__